import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/app/(alfamall)/wishlist/WishListModule/MobileWishListModule.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/muhammadnomanibrahim/Comverse Applications/comverse-baseapp-next/components/AccountsPage/AccountsPage.jsx");
